import { render, staticRenderFns } from "./headerTitle.vue?vue&type=template&id=4953fb68"
import script from "./headerTitle.vue?vue&type=script&lang=js"
export * from "./headerTitle.vue?vue&type=script&lang=js"
import style0 from "./headerTitle.vue?vue&type=style&index=0&id=4953fb68&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports